import React from 'react';
import Banner from '../Banner/Banner';
import Blogs from '../Blogs/Blogs';
import Footer from '../Footer/Footer';
import Introduction from '../Introduction/Introduction';
import Projects from '../Projects/Projects';
import Qualifications from '../Qualifications/Qualifications';
import Skills from '../Skills/Skills';
import TopBanner from '../TopBanner/TopBanner';
import ScrollSpy from "react-ui-scrollspy";


const Home = () => {

    return (
        <ScrollSpy>
            <TopBanner></TopBanner>
            <Banner></Banner>
            <Introduction></Introduction>
            <Skills></Skills>
            <Projects></Projects>
            <Qualifications></Qualifications>
            <Blogs></Blogs>
            <Footer></Footer>
        </ScrollSpy>
    );
};

export default Home;